import io from "socket.io-client";
import React, { useCallback, useEffect, useState, useMemo } from "react";
import { SOCKET_URL } from "../Constants";

// Lazy-initialized socket instance
let socketInstance = null;

const getSocket = () => {
  if (!socketInstance) {
    socketInstance = io(SOCKET_URL, {
      autoConnect: false,
      reconnectionAttempts: 10
    });
  }
  return socketInstance;
};

export const SocketContext = React.createContext();

export const SocketContextProvider = ({ children }) => {
  const [socket, setSocket] = useState(null);

  useEffect(() => {
    // Defer socket initialization until component mounts
    const socket = getSocket();
    setSocket(socket);
  }, []);

  const value = useMemo(() => ({
    socket,
    getSocket
  }), [socket]);

  return (
    <SocketContext.Provider value={value}>
      {children}
    </SocketContext.Provider>
  );
};

export { getSocket };
